import { IMAGES } from "@/lib/site";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-32 md:pt-40 lg:pt-44 pb-20 md:pb-28 overflow-hidden"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
                    <div className="col-span-12 lg:col-span-8">
                        <div className="flex items-center gap-4 mb-10">
                            <span className="block w-10 h-px bg-ochre" />
                            <span
                                className="eyebrow text-ink2"
                                data-testid="hero-eyebrow"
                            >
                                An emerging platform
                            </span>
                        </div>

                        <h1
                            data-testid="hero-headline"
                            className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] xl:text-[6.5rem] leading-[0.95] tracking-tight text-ink"
                        >
                            Indigenous-led
                            <br />
                            stewardship for{" "}
                            <em className="italic font-light text-eucalyptus">
                                land,
                            </em>
                            <br />
                            <em className="italic font-light text-eucalyptus">
                                sea, water
                            </em>{" "}
                            and{" "}
                            <span className="text-ochre">
                                future
                                <br />
                                generations.
                            </span>
                        </h1>
                    </div>

                    <div className="col-span-12 lg:col-span-4 flex flex-col gap-8 lg:pb-4">
                        <div className="rule-top pt-6">
                            <p
                                data-testid="hero-sub"
                                className="text-ink2 text-[15px] md:text-base leading-relaxed max-w-md"
                            >
                                Caring for Country is an emerging platform
                                exploring Indigenous-led approaches to{" "}
                                <span className="text-ink">land management,</span>{" "}
                                <span className="text-ink">restoration,</span>{" "}
                                <span className="text-ink">food security,</span>{" "}
                                <span className="text-ink">native seed systems,</span>{" "}
                                <span className="text-ink">climate resilience</span>{" "}
                                and{" "}
                                <span className="text-ink">community development.</span>
                            </p>
                            <p className="mt-4 text-ink2 text-[15px] md:text-base leading-relaxed max-w-md italic">
                                We believe healthy Country, strong communities
                                and local decision-making are inseparable.
                            </p>
                        </div>
                        <div className="flex flex-wrap items-center gap-4">
                            <a
                                href="#what"
                                data-testid="hero-cta-primary"
                                className="inline-flex items-center px-6 py-3.5 bg-ink text-bone text-[11px] tracking-[0.22em] uppercase hover:bg-eucalyptus transition-colors"
                            >
                                What we do
                            </a>
                            <a
                                href="#contact"
                                data-testid="hero-cta-secondary"
                                className="inline-flex items-center px-6 py-3.5 border border-ink text-ink text-[11px] tracking-[0.22em] uppercase hover:bg-ink hover:text-bone transition-colors"
                            >
                                Start a conversation
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Full-bleed image strip */}
            <div className="mt-16 md:mt-24 grain relative">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                    <div className="relative overflow-hidden h-[55vh] md:h-[70vh] border border-rule">
                        <img
                            src={IMAGES.hero}
                            alt="Expansive Australian Country — red earth and open sky"
                            data-testid="hero-image"
                            className="absolute inset-0 w-full h-full object-cover animate-slow-pan"
                            loading="eager"
                        />
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-ink/30" />
                        <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10 right-6 md:right-10 flex items-end justify-between gap-6">
                            <div className="text-bone max-w-md">
                                <span className="eyebrow opacity-80">
                                    Country
                                </span>
                                <p className="font-serif text-xl md:text-2xl leading-snug mt-2">
                                    Healthy Country, strong communities and
                                    local decision-making are inseparable.
                                </p>
                            </div>
                            <span className="number-mark text-bone/80 hidden md:inline">
                                01 / Country
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
